<template>
  <base-form
    v-model="data"
    :options="options"
    labelWidth="100px"
    :disabled="disabled"
    ref="form"
  ></base-form>
</template>

<script>
  import baseForm from '@/components/form/base-form';
  import BASE_API from '@/api/dataBase.js';
  export default {
    components: {
      baseForm,
    },
    props: {
      defaultData: {
        type: Object,
        default: () => {},
      },
      userInfo: {
        type: Object,
        default: () => {},
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        data: {},
      };
    },
    computed: {
      options() {
        return [
          {
            type: 'input',
            label: this.$t('departmentBusinessAdd.businessId'),
            prop: 'tradeNo',
            disabled: true,
            placeholder: this.$t('departmentBusinessAdd.businessIdPlaceholder'),
          },
          {
            type: 'input',
            label: this.$t('departmentBusiness.orderMakeName'),
            prop: 'tradeCreatePersonName',
            disabled: true,
            required: true,
          },
          {
            type: 'ajaxSelect',
            label: this.$t('departmentBusiness.status'),
            prop: 'tradeStatus',
            apiUrl: BASE_API.DIC_CREDIT_API,
            apiData: { dictType: 'department_business_status' },
            disabled: true,
          },
          {
            type: 'input',
            label: this.$t('departmentBusinessAdd.compnany'),
            prop: 'companyName',
            disabled: true,
            required: true,
          },
          {
            type: 'input',
            label: this.$t('departmentBusinessAdd.department'),
            prop: 'departmentName',
            disabled: true,
            required: true,
          },
          {
            type: 'date',
            label: this.$t('departmentBusiness.orderMakeTime'),
            prop: 'tradeCreateDate',
            disabled: true,
          },
        ];
      },
    },
    watch: {
      defaultData() {
        this.setData();
      },
    },
    mounted() {
      this.setData();
    },
    methods: {
      setData() {
        const userInfo = this.userInfo;
        const data = Object.assign(
          {
            companyCode: userInfo.companyCode,
            companyName: userInfo.companyName,
            departmentName: userInfo.departmentName,
            departmentCode: userInfo.departmentCode,
            tradeCreatePersonName: userInfo.userName,
            tradeCreatePersonNo: userInfo.userCode,
            adminFlag: userInfo.adminFlag,
            tenantCode: userInfo.tenantCode,
          },
          this.data,
          this.defaultData
        );
        this.data = data;
      },
      // 获取数据
      getValues() {
        const data = this.data;
        const result = Object.assign({}, data, {});
        return result;
      },
      handleSubmit() {
        return this.$refs['form'].handleSubmit();
      },
    },
  };
</script>
